type ParseHypeItErrorMessageArgsType = {
  code: string;
  description: string | null;
  translations: Record<string, unknown>;
};

export const parseHypeItErrorMessage = (
  error: ParseHypeItErrorMessageArgsType | null | undefined
): string | null => {
  if (!error) return null;

  const translation = error.translations['en'];
  if (typeof translation === 'string' && translation !== '') {
    return translation;
  }

  return error.description ?? error.code;
};
